import { createSelector } from 'reselect'

function convertOrderBedbankItemToCartItem(orderItem: App.OrderBedbankItem): App.Checkout.BedbankHotelItem {
  const descriptions = orderItem.rooms
    .flatMap(room => room.masterBedGroupDescriptions?.length
      ? room.masterBedGroupDescriptions
      : (room.bedGroup?.description ? [room.bedGroup.description] : []))
    .filter((desc): desc is string => desc !== undefined)
  const uniqueDescriptions = [...new Set(descriptions)]
  const masterBedGroupDescriptions = uniqueDescriptions.length > 0 ? uniqueDescriptions : undefined
  return {
    itemType: 'bedbankHotel',
    itemId: orderItem.id,
    transactionKey: orderItem.transactionKey,
    offerId: orderItem.offer.id,
    checkIn: orderItem.checkIn.format('YYYY-MM-DD'),
    checkOut: orderItem.checkOut.format('YYYY-MM-DD'),
    duration: orderItem.duration,
    total: orderItem.total,
    roomId: orderItem.roomTypeId,
    roomRateId: orderItem.roomRateId,
    orderItemId: orderItem.id,
    orderId: orderItem.orderId,
    isFlightBundle: orderItem.rooms.some(room => room.isFlightBundle),
    bedGroupId: orderItem.rooms.find(room => room.bedGroup)?.bedGroup?.id ?? '',
    masterBedGroupDescriptions,
    occupancy: orderItem.rooms.reduce((acc, room) => {
      acc.adults += room.occupancy.adults ?? 0
      acc.children += room.occupancy.children ?? 0
      acc.infants += room.occupancy.infants ?? 0
      return acc
    }, { adults: 0, children: 0, infants: 0 }),
    sessionId: undefined,
    originalItemId: undefined,
    rateGroupId: undefined,
    boardCode: undefined,
    refundable: orderItem.rooms.every(room => room.refundable),
  }
}

const getBedbankOrderItems = createSelector(
  (state: App.State) => state.checkout.cart.existingOrder,
  (existingOrder): Array<App.Checkout.BedbankHotelItem> => {
    if (!existingOrder?.bedbankItems) {
      return []
    }

    return existingOrder.bedbankItems.map(orderItem =>
      convertOrderBedbankItemToCartItem(orderItem),
    )
  },
)

export default getBedbankOrderItems
